import {createSelector, select} from '@ngrx/store';
import {AppState} from "../app.state";
import {AuthState} from "./auth.reducer";


export const selectAuth = (state: AppState) => state.auth;

export const selectTenantRoleData = createSelector(
  selectAuth,
  (state: AuthState) => state.tenantRole
);

